import styled from 'styled-components';

export default styled.div`
height: 88vh; // explicitly define due to nebula html structure;
overflow-y: auto;
`;